import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actions as environmentActions, STATUS } from "reducers/environment";
import { actions as notificationActions } from "reducers/notification";

export const useVerifyPersonRoles = () => {
    const dispatch = useDispatch();
    const [verifiedUser, setUserVerified] = useState(false);
    const verifyPersonRolesRequest = useSelector((state) => state.environment?.verifyPersonRolesRequest);
    const [disabledForm, setDisabledForm] = useState(true);
    const [updatePhone, setUpdatePhone] = useState(false);

    const [previousDocumentValue, setPreviousDocumentValue] = useState(null);

    const verifyPersonRoles = (cuil, role, isSigner) => {
        dispatch(environmentActions.verifyPersonRoles(cuil, role, isSigner));
        setPreviousDocumentValue(cuil);
    };

    const setVerifyUser = (value) => {
        setUserVerified(value);
        if (!value) {
            dispatch(environmentActions.resetVerifyPersonRoles());
            setPreviousDocumentValue(null);
        }
    };

    useEffect(() => {
        const {
            status: verifyPersonRolesRequestStatus,
            value: verifyPersonRolesRequestValue,
            id: verifyPersonRolesRequestId,
            error: verifyPersonRolesRequestError,
        } = verifyPersonRolesRequest;

        if (verifyPersonRolesRequestStatus === STATUS.SUCCESS && verifyPersonRolesRequestId) {
            setUserVerified(true);
            if (verifyPersonRolesRequestValue?.invitationData) {
                dispatch(environmentActions.resetVerifyPersonRoles());
            }
        } else if (verifyPersonRolesRequestStatus === STATUS.FAILURE) {
            setUserVerified(false);
            setPreviousDocumentValue(null);
            dispatch(environmentActions.resetVerifyPersonRoles());
            dispatch(notificationActions.showNotification(verifyPersonRolesRequestError, "error", ["environment"]));
        }
    }, [verifyPersonRolesRequest]);

    const onChangeDocument = (e) => {
        if (
            e.nativeEvent.inputType === "deleteContentBackward" ||
            e.nativeEvent.inputType === "insertFromPaste" ||
            e.nativeEvent.inputType === "historyUndo"
        ) {
            setVerifyUser(false);
            setDisabledForm(true);

            if (e.nativeEvent.inputType === "deleteContentBackward") {
                setPreviousDocumentValue(null);
            }
        }

        /**
         * previousDocumentValue se usa en el caso de tener un CUIL validado,
         * seleccionarlo y sobreescribirlo (no pegar un valor que es el evento insertFromPaste)
         */
        if (
            e.nativeEvent.inputType === "insertText" &&
            previousDocumentValue !== null &&
            previousDocumentValue !== e.target.value
        ) {
            setVerifyUser(false);
            setDisabledForm(true);
            setPreviousDocumentValue(null);
        }
    };

    const resetForm = (formRef) => {
        if (formRef && !formRef.current) {
            return;
        }

        formRef.current.setFieldValue(
            "phoneNumber",
            {
                value: "",
                countryCode: "",
                areaCode: "",
            },
            false,
        );
        formRef.current.setFieldTouched("phoneNumber", false, false);

        formRef.current.setFieldValue("email", "", false);
        formRef.current.setFieldTouched("email", false, false);
    };

    return {
        verifiedUser,
        setVerifyUser,
        disabledForm,
        setDisabledForm,
        updatePhone,
        setUpdatePhone,
        verifyPersonRolesRequest,
        verifyPersonRoles,
        onChangeDocument,
        resetForm,
    };
};

export default useVerifyPersonRoles;
